export default __webpack_public_path__ + "static/media/FASSADEN.c5133591.jpg";